import { ReactNode } from "react";

import { Button } from "@/components/Interface/Button/Button";
import { SubscriptionInfoBox } from "@/components/Portal/DeviceManagement/SubscriptionDetails/SubscriptionDisplay/SubscriptionInfoBox/SubscriptionInfoBox";

/** One "eSIM Profil" row: a title/button header plus its explanatory text. */
export const SimDetailActionRow = ({
  dataTestid,
  title,
  text,
  buttonLabel,
  onClick,
  disabled,
  disabledAction,
}: {
  dataTestid: string;
  title: string;
  text: string;
  buttonLabel: string;
  onClick?: () => void;
  /** Greys out the trigger button - another section is open elsewhere. */
  disabled?: boolean;
  /** Set to render this instead of the trigger button - the action itself is unavailable. */
  disabledAction?: ReactNode;
}) => (
  <SubscriptionInfoBox className="flex items-start gap-2 !overflow-visible">
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p className="text-body-sm font-semibold leading-none text-foreground-primary">
        {title}
      </p>
      <p className="text-body-xs leading-none text-foreground-secondary">
        {text}
      </p>
    </div>
    {disabledAction || (
      <Button
        dataTestid={dataTestid}
        size="sm"
        variant="primary"
        disabled={disabled}
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    )}
  </SubscriptionInfoBox>
);
